import React, { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Dashboard React components
import DSBox from "components/DSBox";
import DSTypography from "components/DSTypography";

// Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Table";
//import DataTabl from "examples/DataTabl";
import DataTable, { createTheme } from "react-data-table-component";
import Export from "react-data-table-component";
import downloadCSV from "react-data-table-component"

import styled from 'styled-components';
//import Button from '../shared/Button';

// Custom styles for the Tables
import styles from "layouts/tables/styles";

// Data
import authorsTableData from "layouts/tables/data/authorsTableData";
import projectsTableData from "layouts/tables/data/projectsTableData";
createTheme(
  'solarized',
  {
    text: {
      primary: '#818282',
      secondary: '#2aa198',
    },
    background: {
      default: '#F5F8F9',
    },
    context: {
      background: '#cb4b16',
      text: '#FFFFFF',
    },
    divider: {
      default: '#C8C8C8',
    },
    button: {
      default: '#2aa198',
      hover: 'rgba(0,0,0,.08)',
      focus: 'rgba(255,255,255,.12)',
      disabled: 'rgba(255, 255, 255, .34)',
    },
    sortFocus: {
      default: '#2aa198',
    },
    striped: {
      default: 'rgba(0, 0, 0, .87)',
      text: '#FFFFFF',
    },
  },
  'light',
);
function Tables() {
  const classes = styles();
  const { columns, rows } = authorsTableData;
  const { columns: prCols, rows: prRows } = projectsTableData;

  const columnsdt = [
    {
      id: "Name",
      name: "Name",
      selector: (row) => row.Name,
      sortable: true
    },
    {
      name: "Position",
      selector: (row) => row.Position,
      sortable: true
    }, {
      name: "Office",
      selector: (row) => row.Office,

    },
    {
      name: "Age",
      selector: (row) => row.Age,
      sortable: true
    },
    {
      name: "Salary",
      selector: "Salary",
      cell: row => <div>{formatter.format(row.Salary)}</div>,
      sortable: true
    },

  ];
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  const playerSummary = [
    {
      "Name": "Jennifer Acosta",
      "Position": "Junior Javascript Developer",
      "Office": "Edinburgh",
      "Age": 25,
      "Start date": "2/1/2013",
      "Salary": 75650
    },
    {
      "Name": "Cara Stevens",
      "Position": "Sales Assistant",
      "Office": "New York",
      "Age": 31,
      "Start date": "12/6/2011",
      "Salary": 145600
    },
    {
      "Name": "Martena Mccray",
      "Position": "Post-Sales support",
      "Office": "Edinburgh",
      "Age": 23,
      "Start date": "3/9/2011",
      "Salary": 324050
    },
    {
      "Name": "Angelica Ramos",
      "Position": "Chief Executive Officer (CEO)",
      "Office": "London",
      "Age": 52,
      "Start date": "10/9/2009",
      "Salary": 1200000
    },
    {
      "Name": "Finn Camacho",
      "Position": "Support Engineer",
      "Office": "San Francisco",
      "Age": 35,
      "Start date": "7/7/2009",
      "Salary": 87500
    },
    {
      "Name": "Hermione Butler",
      "Position": "Regional Director",
      "Office": "London",
      "Age": 47,
      "Start date": "3/21/2011",
      "Salary": 356250
    },
    {
      "Name": "Unity Butler",
      "Position": "Marketing Designer",
      "Office": "San Francisco",
      "Age": 47,
      "Start date": "12/9/2009",
      "Salary": 85675
    },
    {
      "Name": "Fiona Green",
      "Position": "Chief Operating Officer (COO)",
      "Office": "San Francisco",
      "Age": 48,
      "Start date": "3/11/2010",
      "Salary": 850000
    },
    {
      "Name": "Howard Hatfield",
      "Position": "Office Manager",
      "Office": "San Francisco",
      "Age": 51,
      "Start date": "12/16/2008",
      "Salary": 164500
    },
    {
      "Name": "Shad Decker",
      "Position": "Regional Director",
      "Office": "Edinburgh",
      "Age": 51,
      "Start date": "11/13/2008",
      "Salary": 183000
    }
  ]
    ;

  const actionsMemo = React.useMemo(() => <Export onExport={() => downloadCSV(playerSummary)} />, []);

  const handleRowClicked = (row) => {

  };

  const TextField = styled.input`
height: 32px;
width: 200px;
border-radius: 3px;
border-top-left-radius: 5px;
border-bottom-left-radius: 5px;
border-top-right-radius: 0;
border-bottom-right-radius: 0;
border: 1px solid #e5e5e5;
padding: 0 32px 0 16px;

&:hover {
  cursor: pointer;

}
`;

  const ClearButton = styled.button`
border-top-left-radius: 0;
border-bottom-left-radius: 0;
border-top-right-radius: 5px;
border-bottom-right-radius: 5px;
height: 34px;
width: 32px;
text-align: center;
display: flex;
align-items: center;
justify-content: center;
`;

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <TextField
        id="search"
        type="text"
        placeholder="Filter By Name"
        aria-label="Search Input"
        value={filterText}
        onChange={onFilter}
        key="textsearch"
        autoFocus="autoFocus"
      />
      <ClearButton type="button" onClick={onClear}>
        X
      </ClearButton>
    </>
  );

  const [filterText, setFilterText] = React.useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const filteredItems = playerSummary.filter(
    item => item.Name && item.Name.toLowerCase().includes(filterText.toLowerCase()),
  );

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };

    return (
      <FilterComponent onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
    );
  }, [filterText, resetPaginationToggle]);

  return (

    <DashboardLayout>
      <DashboardNavbar />
      <DSBox py={3}>
        <DSBox mb={3}>
          <Card>
            <DSBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <DSTypography variant="h6">Employees</DSTypography>
            </DSBox>
            <DSBox customClass={classes.tables_table}>
              <Table columns={columns} rows={rows} />
            </DSBox>
          </Card>
        </DSBox>
        <Card>
          <DSBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <DSTypography variant="h6">Projects</DSTypography>
          </DSBox>
          <DSBox customClass={classes.tables_table}>
            <Table columns={prCols} rows={prRows} />
          </DSBox>
        </Card>
      </DSBox>
      <DSBox py={3}>
        <DSBox mb={3}>
          <Card>
            <DSBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <DSTypography variant="h6">Employees</DSTypography>
            </DSBox>
            <DSBox customClass={classes.tables_table}>
              <DataTable
                title="Summary"
                columns={columnsdt}
                data={filteredItems}
                defaultSortFieldId="Name"
                pagination={5}
                onRowClicked={handleRowClicked}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
                theme="solarized"
                highlightOnHover
              />
            </DSBox>
          </Card>
        </DSBox>

      </DSBox>

      <Footer />
    </DashboardLayout>

  );
}

export default Tables;
